import React from "react";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import TabbedHeader from "../../../../../Utils/layout/components/header/TabbedHeader/TabbedHeader";
import { Tracker } from "../../../../util/analytics";
import * as helpers from "../../../../util/helpers";
import { useMobileViewport } from "../../../../util/mobileViewPort";
import { setSettingsPageTabIndex } from "../../state/slices/settingsSlice";

const configurationTabLabelsMap = {
  hookapi: "Hook Api",
  agentsettings: "Agent Settings",
  queueSettings: "Queue Settings",
  callflow: "Call Flow",
  smsflow: "SMS Flow",
  // callgroups: "Call Groups",
  integrations: "Integrations",
};

const SettingsHeader = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedTab = useSelector((state) => state.settingsSlice.activeTab);

  const isFeatureEnabled = (feature) => {
    return helpers.isFeatureEnabled(feature);
  };

  const settingsTabPaths = [
    ...((isFeatureEnabled("is_hook_api_enabled") && helpers.isFeatureEnabledProfile('hookapi_enabled') && ["hookapi"]) || []),
    ...((isFeatureEnabled('is_agent_setting_enabled') && ["agentsettings"]) || []),
    ...((helpers.isCallCenterEnabled() && ['queueSettings']) || []),
    ...(!helpers.isFeatureEnabledProfile('hide_iframe_redirection') ? [
    ...((!helpers.isCPSettingsAvailable('settings_call_flow') && ["callflow"]) || []),
    ...(((!helpers.isCPSettingsAvailable('settings_sms_flow') && helpers.isUIParamsAvailable('smsflow') && helpers.isFeatureEnabledProfile("is_sms_enabled")) && ["smsflow"]) || []),
    // ...((helpers.isCallCenterEnabled() && ["callgroups"]) || []),
    ...(helpers.isUIParamsAvailable('integrations') && (!helpers.isSuperVisor() || (!helpers.isFeatureEnabledProfile('disable_supervisors_access_integrations') && !helpers.isCPSettingsAvailable('settings_integrations'))) ? ["integrations"] : [])
    ] : [])
  ];

  const splitLocationPathname = useCallback(() => {
    return location.pathname.split("/")[1];
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname) {
      Object.keys(settingsTabPaths).forEach((path, index) => {
        if (configurationTabLabelsMap[splitLocationPathname()]) {
          if (splitLocationPathname() === settingsTabPaths[index]) {
            handleOnTabChange(null, index);
          } else {
            if (!settingsTabPaths.includes(splitLocationPathname())) {
              history.push(`/`);
            }
          }
        }
      });
    }
  }, [splitLocationPathname]);

  const handleOnTabChange = (event, newValue) => {
    dispatch(setSettingsPageTabIndex(newValue));
    history.push(`/${settingsTabPaths[newValue]}`);
    if (event) {
      Tracker.event(
        "Hook API",
        `Click`,
        "Hook API Click top bar",
        "",
        helpers.getUser()
      );
    }
  };

  return (
    <div className="d-flex flex-grow-1">
      {!useMobileViewport() && (
        <TabbedHeader
          value={selectedTab}
          ariaLabel="settings"
          handleChange={handleOnTabChange}
          tabList={[
            ...((isFeatureEnabled('is_hook_api_enabled') && helpers.isFeatureEnabledProfile('hookapi_enabled') && ["Hook API"]) || []), 
            ...((isFeatureEnabled('is_agent_setting_enabled') && ["Agent Settings"]) || []),
            ...((helpers.isCallCenterEnabled() && ['queue Settings']) || []),
            ...(!helpers.isFeatureEnabledProfile('hide_iframe_redirection') ? [
            ...((!helpers.isCPSettingsAvailable('settings_call_flow') && ["Call Flow"]) || []),
            ...(((!helpers.isCPSettingsAvailable('settings_sms_flow') && helpers.isUIParamsAvailable('smsflow') && helpers.isFeatureEnabledProfile("is_sms_enabled")) && ["SMS Flow"]) || []),
            // ...((helpers.isCallCenterEnabled() && ["Call Groups"]) || []),
            ...(helpers.isUIParamsAvailable('integrations') && (!helpers.isSuperVisor() || (!helpers.isFeatureEnabledProfile('disable_supervisors_access_integrations') && !helpers.isCPSettingsAvailable('settings_integrations'))) ? ["Integrations"] : [])
            ] : [])
          ]}
        />
      )}
    </div>
  );
};

export default SettingsHeader;
